import { render, staticRenderFns } from "./CameraLocationText.vue?vue&type=template&id=1072c306&"
import script from "./CameraLocationText.vue?vue&type=script&lang=js&"
export * from "./CameraLocationText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports